import React = require("react");
import {CSSProperties, ReactNode} from "react";
import "./CardBox.scss";

interface CardBoxProps {
    title: string;
    value: string;
    valueUp?: boolean;
    footer?: string | JSX.Element;
    onClick?: (...args: any[]) => void;
    backgroundColor?: string;
    bolder?: boolean;
    extended?: boolean;
}

/**
 * A rectangular box with a title, a value and an optional image/footer.
 */
export const CardBox: React.SFC<CardBoxProps> = (props: CardBoxProps) => {

    const containerColor: CSSProperties = {
        backgroundColor: props.backgroundColor,
    };
    let glyphicon: ReactNode = null;
    if (props.valueUp != null) {
        let src = "images/glyphicons/";
        if (props.valueUp) {
            src += "arrow-up";
        } else {
            src += "arrow-down";
        }
        src += ".png";
        glyphicon = <img className="content__glyphicon" src={src}/>;
    }
    return (
        <div className="card-box">
            <div className="card-box__container" style={containerColor}>
                <div className="card-box__content">
                    <p className="content__title">{props.title}</p>
                    <p className="content__value">
                        {props.value}
                        {glyphicon}
                    </p>
                    <span className="content__footer">{props.footer}</span>
                </div>
            </div>
        </div>
    );
};

export const CardBoxSmall: React.SFC<CardBoxProps> = (props: CardBoxProps) => {
    const containerColor: CSSProperties = {
        backgroundColor: props.backgroundColor,
    };
    let valueClasses = "content__value";
    if (props.bolder != null && props.bolder) {
        valueClasses += " bolder";
    }
    let cardBoxClasses = "card-box card-box-small";
    if (props.extended != null && props.extended) {
        cardBoxClasses += " extended";
    }
    const cardBoxContainerClasses = "card-box__container ";
    return (
        <div
            className={cardBoxClasses}
            onClick={props.onClick}
            style={{
                cursor: props.onClick ? "pointer" : undefined,
            }}
        >
            <div className={cardBoxContainerClasses} style={containerColor}>
                <div className="card-box__content">
                    <p className="content__title">{props.title}</p>
                    <p className={valueClasses}>{props.value}</p>
                </div>
            </div>
        </div>
    );
};
